// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".receive-request-histories-table-component .detail-btn[data-v-f2ec2b82]{width:104px}.receive-request-histories-table-component .reply-btn[data-v-f2ec2b82]{width:64px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
